import './assets/styles/main.css'

import './assets/javascript/pwa.install'
import './assets/javascript/popup.ios.intall'

import App from './App.svelte'

const app = new App({
  target: document.body
})

export default app
